import React from "react";
import { Phone } from "lucide-react";
import { COLLEGE } from "../data/college";
import { useT } from "../i18n/LanguageProvider";

const LangToggle = () => {
  const { lang, toggle } = useT();
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="lang-toggle"
      aria-label="Toggle language"
      className="relative h-9 px-1 flex items-center gap-1 rounded-full border border-[#00E5FF]/30 bg-[#04060a]/60 hover:border-[#39FF14]/50 transition"
    >
      <span
        className={`px-2.5 py-1 rounded-full font-mono text-[10px] tracking-[0.2em] uppercase transition ${
          lang === "en"
            ? "bg-[#00E5FF] text-[#04060a]"
            : "text-white/60 hover:text-white"
        }`}
      >
        EN
      </span>
      <span
        className={`px-2.5 py-1 rounded-full font-malayalam text-[12px] transition ${
          lang === "ml"
            ? "bg-[#39FF14] text-[#04060a]"
            : "text-white/60 hover:text-white"
        }`}
      >
        മല
      </span>
    </button>
  );
};

const Navbar = () => {
  const { t } = useT();

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="absolute inset-0 bg-[#04060a]/80 backdrop-blur-xl border-b border-[#00E5FF]/15" />
      <nav className="relative max-w-[1400px] mx-auto px-4 sm:px-5 md:px-10 h-16 md:h-20 flex items-center justify-between gap-3">
        {/* Logo / Wordmark */}
        <a
          href="#hero"
          className="flex items-center gap-2 group flex-shrink-0"
          data-testid="nav-logo"
        >
          <span className="font-heading text-base sm:text-lg md:text-xl font-bold tracking-tight text-white whitespace-nowrap">
            MAR ELIAS
            <span className="text-[#00E5FF] text-glow-cyan">.</span>
          </span>
          <span className="hidden md:inline font-mono text-[9px] tracking-[0.25em] uppercase text-[#39FF14] border-l border-white/15 pl-2 ml-1">
            College
          </span>
        </a>

        {/* Status pill */}
        <div className="hidden lg:flex items-center gap-6">
          <div className="flex items-center gap-2 px-3 py-1.5 border border-[#39FF14]/30 bg-[#39FF14]/5 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-[#39FF14] pulse-dot" />
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#39FF14] whitespace-nowrap">
              {t("nav.admissionsOpen")}
            </span>
          </div>
          <a
            href="#programs"
            className="font-heading text-sm uppercase tracking-[0.18em] text-white/70 hover:text-[#00E5FF] transition"
            data-testid="nav-programs"
          >
            {t("nav.programs")}
          </a>
          <a
            href="#contact"
            className="font-heading text-sm uppercase tracking-[0.18em] text-white/70 hover:text-[#00E5FF] transition"
            data-testid="nav-contact"
          >
            {t("nav.contact")}
          </a>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <LangToggle />
          <a
            href={`tel:+91${COLLEGE.phone_primary}`}
            className="btn-call !py-2.5 !px-3 sm:!px-4 md:!px-5 !text-[11px] sm:!text-xs md:!text-sm"
            data-testid="nav-call-btn"
          >
            <Phone className="w-4 h-4" strokeWidth={2.5} />
            <span className="hidden sm:inline">
              {t("nav.call")} {COLLEGE.phone_primary}
            </span>
            <span className="sm:hidden">{t("nav.call")}</span>
          </a>
        </div>
      </nav>
      <div className="absolute bottom-0 left-0 right-0 h-px line-sweep" />
    </header>
  );
};

export default Navbar;
